import styled from 'styled-components';
import Colors from '../../styles/theme/colors';
import BackgroundImage from '../../assets/logo-symbol.svg';
import { devices } from '../../styles/theme/devices';
import spaces from '../../styles/theme/spaces';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: flex-start;
  padding: 56px 0;
  text-align: center;

  @media ${devices.laptopL} {
    background-attachment: fixed;
    background-image: url(${BackgroundImage});
    background-position: -490px 160px;
    background-repeat: no-repeat;
  }
`;

const Card = styled.div`
  align-items: flex-start;
  background-color: ${Colors.default.white};
  border-radius: 4px;
  border: solid 1px ${Colors.default.lightGrey};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: ${spaces.medium};
  max-width: 600px;
  padding: ${spaces.small};
  text-align: left;
`;

const CardHeader = styled.div`
  align-self: flex-start;
  margin-bottom: ${spaces.medium};
`;

const Form = styled.form`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export { Card, CardHeader, Container, Form };
